import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  CardBody,
  TabContent,
  TabPane,
  ButtonToggle,
  CardFooter,
} from "reactstrap";

import { useFormik } from "formik";
import * as Yup from "yup";
import {
  AGENCY_IDLOGO_URL,
  DOG_CATEGORY_ANSWER,
  DOG_CREATE_URL,
  DOG_LICENSE_DETAILS,
  DOG_REQUIRED_DOCUMENT_ANSWERS,
  GET_DOG_LICENCE_ID,
  LICENSE_URL,
  SAVE_LOOKUP_DETAILS,
  SINGLE_DOG_DETAILS_URL,
  STATE_LIST,
  UPDATE_END_USER,
  UPDATE_LOOKUP_DETAILS,
  USER_CREATE_URL,
} from "../../constants/ApiPaths";
import { CustomAlertMessage } from "../../functions/CustomFunctions";
import { useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import API from "../../redux/actions/API";
import { customerName, customerState } from "../../functions/CoreFunctions";
import { getCustomerUrl, getAuthAgencyId } from "../common/CommonFunctions";
import {
  TTID,
  CUSTOMER_PAYMENT_DOG_LICENSE_ID,
} from "../../constants/LocalStorageVariables";
import CustomPageLoading from "../CustomComponents/CustomPageLoading";
import { Fragment } from "react";
import PageNotFound from "../PageNotFount";
import { useDispatch, useSelector } from "react-redux";
import CustomButtonLoader from "../CustomComponents/CustomButtonLoader";

import HeaderLogo from "../common/HeaderLogo";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { JSONParser } from "../../functions/Helper";
import {
  AGENCY_DELETE,
  DOG_PLAN_DETAILS_SUCCESS,
  END_USER_DETAILS_SUCCESS,
  GOTO_NEXT_STEP,
  GOTO_PREVIOUS_STEP,
  GOTO_SELECTED_STEP,
} from "../../redux/actions/ActionTypes";
import moment from "moment";
import Background from "../../images/cus-bg.svg";
import classnames from "classnames";
import UserInformation from "./UserInformation";
import Chooseplan from "./License/Chooseplan";
import UserSuccessDetails from "./UserSuccessDetails";

import PaymentWithPlan from "./License/PaymentWithPlan";
import AgencyPaymentWithPlan from "./License/AgencyPaymentWithPlan";
import YupSchemaCreator from "../Agency/Template/YupSchemaCreator";
import PreviewDetails from "./License/PreviewDetails";

const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  gender: "",
  dateOfBirth: "",
  usphoneNumber: "+1 ",
  phoneNumber: "+1 ",
  profileImage: "",
  stateId: "",
  city: "",
  address: "",
  zip: "",
  agencyUrl: "",
  dogName: "",
  breed: "",
  color: "",
  DOB: "",
  sex: "",
  dogImageUrl: "",
  dogDescription: "",
};

function UserSignin() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [planId, setPlanId] = useState("");
  const [pageloading, setPageLoading] = useState(true);
  const [authFlag, setAuthFlag] = useState(false);
  const [compleFlag, setCompleteFlag] = useState(false);
  const [futureFlag, setFutureFlag] = useState(false);
  const [answers, setAnswers] = useState({});
  const [validationSchema1, setValidationSchema1] = useState({});
  const [documentUrl, setDocumentUrl] = useState("");
  const [licenseDetails, setlicenseDetails] = useState({});
  const [stateList, setStateList] = useState([]);

  const { enqueueSnackbar } = useSnackbar();
  const [agencyPlans, setAgencyPlans] = useState([]);
  let { agencyUrl } = useParams();
  const [moreflag, setMoreFlag] = useState(false);
  const [dogLicId, setDogLicenseId] = useState();
  console.log("url", agencyUrl);
  const today = new Date();
  const [customerId, setCustomerId] = useState();
  const [dogId, setDogId] = useState();
  // const [currentStep, setCurrentStep] = useState(1);
  const [singledog, setSingleDog] = useState([]);
  const ApplicationForm = useSelector((state) => state.FieldValidateReducer);
  const { currentStep = 1 } = ApplicationForm;
  const { licenseRequiredDocDetails = [], categoryDetails = [] } = useSelector(
    (state) => state.CustomerFormReducer
  );
  const categoryData = JSONParser(categoryDetails, []);
  const currentUrl = window.location.pathname;
  const isAgencyPage = currentUrl.includes("agencyplan");
  
  localStorage.setItem("CUSTOMER_URL", agencyUrl);
  const data = useSelector((state) => state.DogPlanDetailsReducer);
 console.log('locals-2--');
const [showErrors, setShowErrors] = useState(false);

useEffect(() => {
  dispatch({
    type: GOTO_SELECTED_STEP,
    payload: 1,
  });
}, [dispatch]);

  useEffect(() => {
    let questions = [];
    categoryDetails.forEach((e) => {
      questions.push(...e.categoryPlaceHolder);
    });

    console.log(questions, "questions");

    questions = questions.filter((e) => e.isMandatory);
    questions = questions.map((question) => {
      if (question.type === "checkbox") {
        console.log("question", question);

        question.validationType = "array";
        question.validations = [
          {
            type: "min",
            params: [1], // at least one checkbox should be selected
          },
        ];
      }
      return question;
    });
    const yupSchema = questions.reduce(YupSchemaCreator, {});
    const schema = Yup.object().shape(yupSchema);

    setValidationSchema1(schema);
  }, [answers]);

  useEffect(() => {
    let answers = {};

    const specialfunction = {
      PET_VALUE: singledog.dogName,
      USER_NAME: customerName(),
      PET_BREED: singledog.breed,
      CUSTOMER_STATE: customerState(),
      PET_COLOR: singledog.color,
    };
    if (data.categoryDetails) {
      const { categoryDetails = {} } = data;
      // licenseRequiredDocDetails.forEach((e) => {
      //   answers[e.licenseRequiredDocId] =
      //     categoryDetails[e.licenseRequiredDocId];
      // });

      setAnswers(categoryDetails);
      console.log("redux c", answers);
    } else {
      console.log("redux else part");

      categoryDetails.forEach(({ categoryPlaceHolder = [] }) => {
        categoryPlaceHolder.forEach(({ uniqueId, type, specialvalue }) => {
          if (!uniqueId) return;
          if (specialvalue) {
            answers[uniqueId] = specialfunction[specialvalue];
          } else {
            answers[uniqueId] = type === "checkbox" ? [] : "";
          }
        });
      });
      licenseRequiredDocDetails.forEach((e) => {
        answers[e.licenseRequiredDocId] = "";
      });
      console.log("answers", answers);
      console.log("cdetails", categoryDetails);
      setAnswers(answers);
    }
  }, [categoryDetails, licenseRequiredDocDetails, singledog]);
  const Answer = categoryData.map((ans) => JSONParser(ans.categoryAnswer, []));
  let csvHeaders = [];
  let csvAnswer = {};
  //  const { planName } = licensePlanData[0] || {};
  Answer.forEach((A, index) => {
    A.categoryPlaceHolder.forEach((field) => {
      csvHeaders.push({ label: field?.label, key: field.uniqueId });
      if (["select", "checkbox", "radio"].includes(field.type)) {
        let fieldValueAnswer = field.selectedAnswer;
        if (field.type === "checkbox") {
          let CheckboxAnswer = [];
          field.options.forEach((option) => {
            if (fieldValueAnswer.includes(option.value)) {
              CheckboxAnswer.push(option.value);
            }
          });
          fieldValueAnswer = CheckboxAnswer.join(",");
        } else {
          let fieldValue = field.options.find(
            (o) => o.value === field.selectedAnswer
          );
          fieldValueAnswer = !!field.selectedAnswer && fieldValue?.label;
        }
        csvAnswer[field.uniqueId] = fieldValueAnswer;
      } else {
        csvAnswer[field.uniqueId] = field.selectedAnswer;
      }
    });
  });
  const validationSchemaDefault = Yup.object({});
  const validationSchema = Yup.object({
    firstName: Yup.string().trim().required("First Name is required"),
    lastName: Yup.string().trim().required("Last Name is required"),
    email: Yup.string().trim().required("Email is required"),
    // phoneNumber: Yup.string().phoneNumberValidation("Invalid Phone Number"),
    dogName: Yup.string().trim().required(" Name is required"),
    breed: Yup.string().trim().required("Breed is required"),
    color: Yup.string().trim().required("Color is required"),
    DOB: Yup.date()
      .nullable()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      )
      .max(today, "Invalid Date of Birth"),
    sex: Yup.string().trim().required("Gender is required"),
    dogDescription: Yup.string().trim().required("Description is required"),
  });
  // const generatePdfContent = (data) => {
  //   // Extract necessary data from the provided data object
  //   const {
  //     dogId,
  //     userId,
  //     requestedDate,
  //     // ... extract other required data
  //   } = data;

  //   // Return JSX representing the PDF content
  //   return (
  //     <div>
  //       <h1>Dog License Details</h1>
  //       <p>Dog ID: {dogId}</p>
  //       <p>User ID: {userId}</p>
  //       <p>Requested Date: {requestedDate}</p>
  //       {/* Add more content based on your data structure */}
  //     </div>
  //   );
  // };

  const fetchStateList = async () => {
    const config = {
      method: "GET",
      url: STATE_LIST,
      // headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        const { data } = response.data;
        setStateList(data);
        //  setState(values.state)
      }
    } catch (error) {}
  };
  useEffect(() => {
    fetchStateList();
  }, []);

  useEffect(() => {
    const updateDogUrl = async (dogLicenseID) => {
      const config = {
        method: "PUT",
        url: LICENSE_URL,
        data: {
          dogLicenseId: dogLicenseID,
          licenseUrl: documentUrl,
        },
      };
      try {
        const res = await API(config);
        console.log("res", res);
      } catch (error) {
        console.error(error);
      }
    };
    if (dogLicId && documentUrl) {
      updateDogUrl(dogLicId);
    }
  }, [documentUrl, dogLicId]);
  const handleFormSubmit = async (values) => {
    console.log("form submit", values);
    setLoading(true);

    try {
      const licenseUrlBasedOnPage = isAgencyPage ? `${window.location.origin}/agencyplan/${getCustomerUrl()}/view-license/${planId}/` : `${window.location.origin}/customer/${getCustomerUrl()}/view-license/${planId}/`;
      let dogLicenseID;
      if (dogLicId > 0) {
        dogLicenseID = dogLicId;
      } else {
      const getLicenseConfig = {
        method: "POST",
        url: GET_DOG_LICENCE_ID,
        // headers: authCustomerHeader(),
        data: {
          dogId: dogId,
          userId: customerId,
          licensePlanId: planId,
          type: "new license", // 'renewal license'
          // licenseUrl: documentUrl,
          licenseUrl: licenseUrlBasedOnPage,
        },
      };

      const response1 = await API(getLicenseConfig);

      dogLicenseID = response1.data?.dogLicenseId;
     
      setDogLicenseId(dogLicenseID);
      // dogLicenseDetails(dogLicenseID);

      console.warn(getLicenseConfig, response1);
      console.log("category", categoryDetails);
       }
      let createLicenseData = {
        dogLicenseId: dogLicenseID,
        categoryDetails: categoryDetails.map((cat) => {
          let catAnswer = { ...cat };
          catAnswer["categoryPlaceHolder"] = cat.categoryPlaceHolder.map(
            (catPlaceHolder) => {
              return {
                ...catPlaceHolder,
                selectedAnswer: values[catPlaceHolder.uniqueId],
              };
            }
          );
          return {
            categoryAnswerId: 0,
            categoryId: cat.categoryId,
            categoryAnswer: JSON.stringify(catAnswer),
          };
        }),
      };
      console.log("create", createLicenseData);

      let createLicenseConfig = {
        method: "POST",
        url: DOG_CATEGORY_ANSWER,
        data: createLicenseData,
      };
      console.log("create", createLicenseConfig);
      const documentDetails = licenseRequiredDocDetails.map((e) => {
        return {
          licenseRequiredDocDetailsId: 0,
          licenseRequiredDocId: e.licenseRequiredDocId,
          filePath: values[e.licenseRequiredDocId],
          documentValidFrom: "",
          documentValidTo: "",
          categoryId: e.categoryid,
        };
      });
      console.log("document details", documentDetails);
      let requiredDocConfig = {
        method: "POST",
        url: DOG_REQUIRED_DOCUMENT_ANSWERS,
        data: {
          dogId: dogId,
          dogLicenseId: dogLicenseID,
          documentDetails: documentDetails,
        },
      };

      await API(createLicenseConfig);
      await API(requiredDocConfig);
      console.log("values doc", values, documentDetails);
      dogLicenseDetails(dogLicenseID);
      window.sessionStorage.setItem(
        CUSTOMER_PAYMENT_DOG_LICENSE_ID,
        dogLicenseID
      );
      window.sessionStorage.setItem("PAYMENT_DOGLICENSE_LICENSEPLANID", planId);
      setLoading(false);
      dispatch({
        type: DOG_PLAN_DETAILS_SUCCESS,
        payload: values,
        documentDetails: documentDetails,
      });

      dispatch({
        type: GOTO_NEXT_STEP,
        payload: currentStep,
      });
      // history(
      //   `/payment/dogLicenseId=${dogLicenseID}&userId=${customerId}&ttId=${ttid}`
      // );
      // setCompleteFlag(true);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const getValidationSchema = (step) => {
    switch (step) {
      case 1:
        return validationSchemaDefault;
      case 2:
        return validationSchema;

      default:
        return validationSchemaDefault;
    }
  };
  const getInitialValues = (step) => {
    switch (step) {
      case 1:
        return initialValues;
      case 2:
        return initialValues;

      // Add more cases if you have additional steps
      default:
        return initialValues;
    }
  };
  const getEnableFlag = (step) => {
    console.log(step, "step");
    if (step === 3) {
      return true;
    } else {
      return false;
    }
  };
  console.log("get", getEnableFlag(currentStep));
  const enableReinitializeValue = getEnableFlag(currentStep);
  console.log("Enable Reinitialize Value:", enableReinitializeValue);
  const formik = useFormik({
    initialValues: getInitialValues(currentStep),
    validationSchema: getValidationSchema(currentStep),
    enableReinitialize: false,
    onSubmit: (values) => {
      console.log("called", answers, errors, getValidationSchema(currentStep));
      if (currentStep === 2) {
        saveFormValues(values);
      }
      // saveFormValuesDog(values);
    },
  });
  const formik1 = useFormik({
    initialValues: {},
    validationSchema: validationSchema1,
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log("called", answers, errors, getValidationSchema(currentStep));
      if (currentStep === 3) {
        handleFormSubmit(values);
        console.log("values", values);
      }
      // saveFormValuesDog(values);
    },
  });
  const { handleSubmit: handleSubmit1 } = formik1;
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    setValues,
    handleBlur,
    setErrors,
    setTouched,
  } = formik;
  console.log(
    "validation on each",
    getValidationSchema(currentStep),
    getInitialValues(currentStep),
    errors
  );
  //Common Signin Functionality

  const saveFormValues = async (values) => {
    setLoading(true);
    const {
      firstName,
      lastName,
      email,
      gender,
      address,
      city,
      stateId,
      usphoneNumber,
      zip,
    } = values;
    const config = {
      method: "POST",
      url: USER_CREATE_URL,
      data: {
        firstName,
        lastName,
        email,
        gender,
        address,
        city,
        stateId: stateId,
        agencyUrl: agencyUrl,
        hyperLink: `${window.location.host}/customer/${agencyUrl}`,
        phoneNumber: usphoneNumber.split("+1 ")[1],
        userId: customerId ? customerId : null,
        zip,
      },
      // headers: authCustomerHeader(),
    };

    try {
      const response = await API(config);
      const { status, userId, message } = response.data;
      if (status === "Success") {
        setCustomerId(userId);
        if (userId && message === "Email Already Exists") {
          const config1 = {
            method: "PUT",
            url: UPDATE_END_USER,
            data: {
              firstName,
              lastName,
              email,
              gender,
              address,
              city,
              stateId: stateId,
              agencyUrl: agencyUrl,
              hyperLink: `${window.location.host}/customer/${agencyUrl}`,
              phoneNumber: usphoneNumber.split("+1 ")[1],
              userId: customerId ? customerId : null,
              zip,
            },
          };
          try {
            const response = await API(config1);
            console.log("resp", response);
          } catch (error) {
            console.error(error);
          }
        }
        if (futureFlag === true) {
          handleSaveFuture(values, userId);
        }
        saveFormValuesDog(values, userId);
        // CustomAlertMessage(
        //   "Account Created successfully!",
        //   "success",
        //   enqueueSnackbar
        // );
        // history(`${USER_SIGNIN}/${agencyUrl}`);
      }
    } catch (error) {
      let { data } = error.response;

      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
      // setLoading(false);
    }
  };
  const saveFormValuesDog = async (values, userId) => {
    const { dogName, breed, color, DOB, sex, dogImageUrl, dogDescription } =
      values;
    // const agencyId = getCustomerAgencyId();
    const agencyId = getAuthAgencyId();
    // setLoading(true);
    const config = {
      method: "POST",
      url: DOG_CREATE_URL,
      data: {
        dogName,
        breed,
        color,
        DOB: DOB ? DOB : null,
        sex,
        dogImageUrl,
        dogDescription,
        agencyId: agencyId,
        dogRegiesterId: userId,
      },
      // headers: authCustomerHeader(),
    };

    try {
      const response = await API(config);
      const { status, dogId } = response.data;

      if (status === "Success") {
        setDogId(dogId);

        CustomAlertMessage("Created Successfully!", "success", enqueueSnackbar);
        if (currentStep === 4) {
        } else {
          dispatch({
            type: GOTO_NEXT_STEP,
            payload: currentStep,
          });
        }
      }
      // successCallBack();
    } catch (error) {
      if (error) {
        let { data } = error.response;

        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };
  const handleSaveFuture = async (values, userId) => {
    setLoading(true);
    const {
      firstName,
      lastName,
      email,
      gender,
      address,
      city,
      stateId,
      usphoneNumber,
      zip,
      dogName,
      breed,
      color,
      DOB,
      sex,
      dogImageUrl,
      dogDescription,
    } = values;
    console.log("values", values, zip);
    const customerDetails = {
      firstName,
      lastName,
      email,
      gender,
      address,
      city,
      stateId,
      phoneNumber: usphoneNumber.split("+1 ")[1],
      userId,
      zip,
      dogName,
      breed,
      color,
      DOB,
      sex,
      dogImageUrl,
      dogDescription,
    };
    const customerDetailsString = JSON.stringify(customerDetails);
    console.log("custom", customerDetails, customerDetailsString);
    // const customerDetailsString = `
    // "{\\"firstName\\":\\"${firstName}\\",
    // \\"lastName\\":\\"${lastName}\\",
    // \\"email\\":\\"${email}\\",
    // \\"gender\\":\\"${gender}\\",
    // \\"address\\":\\"${address}\\",
    // \\"city\\":\\"${city}\\",
    // \\"state\\":\\"${state}\\",
    // \\"phoneNumber\\":\\"${usphoneNumber}\\"}"`;
    const config = {
      method: customerId ? "PUT" : "POST",
      url: customerId ? UPDATE_LOOKUP_DETAILS : SAVE_LOOKUP_DETAILS,
      data: {
        customerDetails: customerDetailsString,
        phoneNumber: values.usphoneNumber.includes("+1")
          ? values.usphoneNumber.split("+1 ")[1]
          : values.usphoneNumber,
      },
    };
    try {
      const response = await API(config);
      console.log(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const planSelectFun = (e) => {
    console.log(e.currentTarget.dataset.licenseplanid);
    setPlanId(e.currentTarget.dataset.licenseplanid);
    CustomAlertMessage("Plan selected", "success", enqueueSnackbar);
    setMoreFlag(false);
    dispatch({
      type: GOTO_NEXT_STEP,
      payload: currentStep,
    });
  };

  useEffect(() => {
    const getAgencyIdandLogo = async () => {
      const config = {
        method: "GET",
        url: AGENCY_IDLOGO_URL,
        params: { agencyUrl: agencyUrl },
      };
      try {
        const response = await API(config);
        const { status, isdeleted, data, agencyId, agencyLogo, ttid } =
          response.data;
        localStorage.setItem("LOGGED_AGENCY_ID", agencyId);
        localStorage.setItem("AGENCYLOGO", agencyLogo);
        localStorage.setItem(TTID, ttid);

        if (status === "Success") {
          const filteredData = data.filter(item =>
            isAgencyPage ? item.isAgencyLicense === true : item.isAgencyLicense !== true
          );
          setAgencyPlans(filteredData);
          setAuthFlag(true);
          // setAgencyPlans(data);
          localStorage.setItem("DELETED_AGENCY", isdeleted);
          dispatch({
            type: AGENCY_DELETE,
            payload: isdeleted,
          });
        } else if (status === "Error") {
          setAuthFlag(false);
        }
      } catch (error) {
        console.error(error);
        // history("/*");
      } finally {
        setPageLoading(false);
      }
    };
    getAgencyIdandLogo();
  }, [agencyUrl]);
  const onTabClick = (tabIndex) => {
     if (planId > 0) {
    if (tabIndex === 3) {
      // setEF(true);
    }
    dispatch({
      type: GOTO_SELECTED_STEP,
      payload: tabIndex,
    });
    } else {
     CustomAlertMessage("Please choose a plan", "error", enqueueSnackbar);
  }
  };

  const goToNextStep = () => {
    // setCurrentStep(currentStep + 1);
    if (currentStep === 1) {
      if (planId === "") {
        CustomAlertMessage("Please choose a plan", "error", enqueueSnackbar);
      } else {
        dispatch({
          type: GOTO_NEXT_STEP,
          payload: currentStep,
        });
      }
    } else if (currentStep === 2) {
      handleSubmit();
    } else if (currentStep === 3) {
      console.log("entr", currentStep);
        if (licenseRequiredDocDetails.length > 0) {
            const missingDocs = licenseRequiredDocDetails.filter((docDetail) => {
              if (docDetail.isMandatory) {
                const filePath = formik1.values[docDetail.licenseRequiredDocId];
                return !filePath;
              }
              return false;
            });
            if (missingDocs.length > 0) {
              console.log("Missing mandatory documents:", missingDocs);
              setShowErrors(true);
            } else {
              console.log("All mandatory documents uploaded");
              setShowErrors(false);
              handleSubmit1();
            }
          } else {
            handleSubmit1();
          }
      // setEF(true);
      // handleFormSubmit(values);
      // handleSubmit1();
    } else {
      dispatch({
        type: GOTO_NEXT_STEP,
        payload: currentStep,
      });
    }
  };
  const goToPreviousStep = () => {
    // setCurrentStep(currentStep - 1);
    if (currentStep === 1) {
    } else {
      dispatch({
        type: GOTO_PREVIOUS_STEP,
        payload: currentStep,
      });
    }
  };
  let dogLicenseDetails = async (id) => {
    //  setloading(true);
    const config = {
      method: "GET",
      url: DOG_LICENSE_DETAILS,
      // headers: pathname == "customer" ? authCustomerHeader() : authHeader(),
      params: {
        dogLicenseId: id,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setlicenseDetails(data);
        // handleGeneratePdf(data);
        //  setlicenseDetails(data);
        //  setReupload({
        //    validFromDate: data.validFromDate,
        //    validToDate: data.validToDate,
        //    dogLicenseNumber: data.dogLicenseNumber,
        //  });
      }
    } catch (error) {
      if (error.response) {
        //  CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      //  setloading(false);
    }
  };

  useEffect(() => {
    const getDogDetails = async () => {
      //  setDetailLoad(true);
      const config = {
        method: "GET",
        url: SINGLE_DOG_DETAILS_URL,
        //  headers: authHeader(),
        params: {
          dogId: dogId,
        },
      };
      try {
        const response = await API(config);
        const { data } = response.data;
        setSingleDog(data);
        // dogLicenseDetails(dogId);
        //  const { dogName, breed, color, DOB, sex, dogImageUrl, dogDescription } =
        //  data;
        //  setFormData({
        //    ...formData,
        //    dogName: dogName,
        //    breed: breed,
        //    color: color,
        //    DOB: DOB,
        //    sex: sex,
        //    dogImageUrl: dogImageUrl,
        //    dogDescription: dogDescription,
        //  });
      } catch (error) {
        console.error(error);
      } finally {
        //  setDetailLoad(false);
      }
    };
    if (dogId) {
      getDogDetails();
    }
  }, [dogId]);
  const ResetAllFormFields = () => {
    setPlanId("");
    setDogId("");
    setDogLicenseId("");
    setValues(initialValues);
    setlicenseDetails({});
    setCustomerId("");
    setErrors("");
    setTouched("");
    dispatch({
      type: END_USER_DETAILS_SUCCESS,
      payload: [],
    });
    dispatch({
      type: GOTO_NEXT_STEP,
      payload: 0,
    });
  };
const stripHtml = (html) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || '';
};
  const InstructionBox = ({ html }) => {
    if (!html) return <div style={{justifyContent: 'center', display: 'flex', fontSize: 'initial' }}>There are no instructions available.</div>;
    const removeTag = html.replace(/<p>/gi, '<p style="margin: 0; padding: 0;">');
    // const removeTag1 = removeTag.replace(/<strong>/gi, '<strong style="margin: 0; padding: 0; display: inline; font-weight: bold; line-height: 1;">');
    const changeTag = removeTag.replace(/<br\s*\/?>/gi, `<div style="line-height: 1em; height: 1.0em;"></div>`);
  return <div style={{margin:0, padding: 0}} dangerouslySetInnerHTML={{ __html: changeTag }} />;
};

  return (
    <div
    // style={{ backgroundImage: `url(${Background})` }}
    >
      {/* <div className="agency-wrapper" id="simp">
        <Container fluid="lg">
          <Card body className="mt-4 license-details">
            <div className="agency-license-view">
              <Row>
                <Col md={{ size: "auto", offset: 0 }}>
                  <h4>{planName}</h4>
                </Col>
              </Row>
            </div>
            <h5>License Details</h5>
            {!isEditable ? (
              <ReuploadFormValue
                setisEditable={setisEditable}
                // sucesscallback={sucesscallback}
                categoryData={categoryData}
                dogId={dogId}
                document={document}
                Answer={Answer}
              />
            ) : (
              <AgencyPreviewform
                isEditable={isEditable}
                document={document}
                Answer={Answer}
              />
            )}
          </Card>
        </Container>
      </div> */}
      {pageloading && <CustomPageLoading />}

      <HeaderLogo userIndex="userIndex" />
      {console.log("length", agencyPlans && agencyPlans.length)}
      {authFlag && compleFlag === false ? (
        <Fragment>
          <div
            className={
              currentStep === 1 ||
              (currentStep === 3 && !dogId) ||
              (currentStep === 4 && !licenseDetails)
                ? "urs-bg-signin"
                : "urs-bg"
            }
            style={{ backgroundImage: `url(${Background})` }}
          >
           <div
              style={{
                backgroundColor: "#FFF3CD",
                border: "1px solid #FFE69C",
                color: "#664D03",
                padding: "16px",
                borderRadius: "8px",
                marginBottom: "-12px",
                fontSize: "12px",
                lineHeight: "0.9",
                marginRight: "120px",
                marginLeft: "120px",
                marginTop: "-5px",
              }}
            >
              <strong>Disclaimer:</strong> PayGov.US is not owned or operated by the U.S.
              government or any state or local government agency or utility.
              <br />
              <br />
              A Convenience Fee will apply to all payments made through this website.
              <br />
              <br />
              If you do not wish to pay a Convenience Fee, please contact your
              agency/creditor regarding alternative methods of payment.
            </div>
            {/* <Container style={{ marginBottom: "14rem !important" }}> */}
            {/* <Row className="align-items-center"> */}
            {/* <LandingPagePlansBlock agencyPlans={agencyPlans} /> */}
            <Card
              style={{
                marginLeft: "119px",
                marginRight: "119px",
                marginBottom: "auto",
                marginTop: "24px",
                minWidth: "1100px",
              }}
            >
              <CardHeader>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames(
                        {
                          active: parseInt(currentStep) === 1,
                        },
                        "cursorHand"
                      )}
                      onClick={() => onTabClick(1)}
                    >
                      Your Plans
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames(
                        {
                          active: parseInt(currentStep) === 2,
                        },
                        "cursorHand"
                      )}
                      onClick={() => onTabClick(2)}
                    >
                      Your Information
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames(
                        {
                          active: parseInt(currentStep) === 3,
                        },
                        "cursorHand"
                      )}
                      onClick={() => onTabClick(3)}
                    >
                      License Details
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames(
                        {
                          active: parseInt(currentStep) === 4,
                        },
                        "cursorHand"
                      )}
                      onClick={() => onTabClick(4)}
                    >
                      Preview
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames(
                        {
                          active: parseInt(currentStep) === 5,
                        },
                        "cursorHand"
                      )}
                      onClick={() => onTabClick(5)}
                    >
                      Payment
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardHeader>
              <CardBody>
                {currentStep == 1 && (
                  <div style={{
                    width: '100%', maxHeight: '180px',
                    border: '1px solid #ccc',
                    fontSize: '14px',
                    padding: '10px',
                    marginBottom: '10px',
                    overflowY: 'auto', // Enables vertical scrolling
                  }}>
                    <h4>Instructions</h4>
                    {(agencyPlans && agencyPlans[0] && agencyPlans[0].instruction && stripHtml(agencyPlans[0].instruction).length) ? (
                       <InstructionBox html={agencyPlans?.[0]?.instruction} />
                    ) : (
                    <div style={{justifyContent: 'center', display: 'flex', fontSize: 'initial' }}>There are no instructions available.</div>
                    )}
                  </div>
                )}
                <TabContent activeTab={parseInt(currentStep)}>
                  <TabPane tabId={1}>
                    <Row>
                      <Col sm="12">
                        <LandingPagePlansBlock
                          agencyPlans={agencyPlans}
                          planSelectFun={planSelectFun}
                          planId={planId}
                          moreflag={moreflag}
                          setMoreFlag={setMoreFlag}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId={2}>
                    <Row>
                      <Col sm="12">
                        <UserInformation
                          currentStep={currentStep}
                          initialValues={initialValues}
                          values={values}
                          errors={errors}
                          handleBlur={handleBlur}
                          touched={touched}
                          handleChange={handleChange}
                          setValues={setValues}
                          customerId={customerId}
                          setCustomerId={setCustomerId}
                          futureFlag={futureFlag}
                          setFutureFlag={setFutureFlag}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId={3}>
                    <Row>
                      <Col sm="12">
                        <Chooseplan
                          licensePlanId={planId}
                          dogId={dogId}
                          singledog={singledog}
                          customerId={customerId}
                          setCompleteFlag={setCompleteFlag}
                          pageloading={pageloading}
                          setPageLoading={setPageLoading}
                          answers={answers}
                          setAnswers={setAnswers}
                          validationSchema={validationSchema1}
                          setValidationSchema={setValidationSchema1}
                          errors={errors}
                          touched={touched}
                          formik={formik1}
                          showErrors={showErrors}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId={4}>
                    <PreviewDetails
                      licensePlanId={planId}
                      dogLicenseId={dogLicId}
                      setDogLicenseId={setDogLicenseId}
                      dogId={dogId}
                      userId={customerId}
                      ResetAllFormFields={ResetAllFormFields}
                      currentStep={currentStep}
                      licenseDetails={licenseDetails}
                      setlicenseDetails={setlicenseDetails}
                      documentUrl={documentUrl}
                      setDocumentUrl={setDocumentUrl}
                      moreflag={moreflag}
                      setMoreFlag={setMoreFlag}
                    />
                  </TabPane>
                  <TabPane tabId={5}>
                     {isAgencyPage ? (
                        <AgencyPaymentWithPlan
                      dogLicenseId={dogLicId}
                      dogId={dogId}
                      userId={customerId}
                      setMoreFlag={setMoreFlag}
                      ResetAllFormFields={ResetAllFormFields}
                      currentStep={currentStep}
                      moreflag={moreflag}
                      licenseDetails={licenseDetails}
                      stateList={stateList}
                      agencyPlans={agencyPlans}
                    />
                     ) : (
                    <PaymentWithPlan
                      dogLicenseId={dogLicId}
                      dogId={dogId}
                      userId={customerId}
                      ResetAllFormFields={ResetAllFormFields}
                      currentStep={currentStep}
                      moreflag={moreflag}
                      setMoreFlag={setMoreFlag}
                      licenseDetails={licenseDetails}
                      stateList={stateList}
                    />
                      )}
                  </TabPane>
                </TabContent>
              </CardBody>
              <CardFooter className="text-muted">
                {parseInt(currentStep) !== 1 && (
                  <ButtonToggle color="secondary" onClick={goToPreviousStep}>
                    {"Back"}
                  </ButtonToggle>
                )}
                {parseInt(currentStep) === 2 ||
                parseInt(currentStep) === 3 ||
                parseInt(currentStep) === 4 ? (
                  <ButtonToggle
                    // form={`endUserWebForm_${currentStep}`}
                    type="submit"
                    color="primary"
                    style={{ float: "right" }}
                    onClick={goToNextStep}
                  >
                    {loading && <CustomButtonLoader />}

                    {"Next"}
                  </ButtonToggle>
                ) : (
                  <></>
                )}
              </CardFooter>
            </Card>
            {/* </Row> */}
            {/* </Container> */}
          </div>
        </Fragment>
      ) : (
        !pageloading && compleFlag === false && <PageNotFound />
      )}
      {compleFlag === true ? <UserSuccessDetails agency={agencyUrl} /> : <></>}
    </div>
  );
}
export default UserSignin;

export const CheckBoxIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.011"
      height="17.011"
      viewBox="0 0 17.011 17.011"
    >
      <path
        id="Icon_material-check-box"
        data-name="Icon material-check-box"
        d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
        transform="translate(-4.5 -4.5)"
        fill="#fff"
      />
    </svg>
  );
};

export const LandingPagePlansBlock = (props) => {
  const { agencyPlans = [], planSelectFun, planId } = props;

  // const gotoNext = () => {
  //   customeSlider.current.slickNext();
  // };

  // const gotoPrev = () => {
  //   customeSlider.current.slickPrev();
  // };

  return (
    <div className="plan-container">
      <div
        className="create-plan plan-list1"
        style={{ display: "flex", columnGap: "10px", overflowX: "scroll" }}
      >
        {agencyPlans.map((plan, e) =>
          plan.planName ? (
            <Col
              md="4"
              className="mb-4"
              key={e}
              // style={{ display: "inline-block", whiteSpace: "normal" }}
            >
              <div
                className="box"
                style={{
                  backgroundColor:
                    planId === plan.licensePlanId ? "#1b3e6f" : "#6c6e72",
                }}
              >
                <h4>{plan.planName}</h4>
                <h1>
                  <strong>$</strong>
                  {parseFloat(plan.planAmount).toFixed(2)}
                </h1>
                <span>
                  {plan.isLifeTimePlan && "Life Time Plan"}

                  {plan.validTo && (
                    <>
                      {" "}
                      <span>Till Date</span>{" "}
                      {moment(plan.validTo).format("MM-DD-YYYY")}
                    </>
                  )}
                  {!!plan.planDuration && plan.planDuration + "/ year"}
                </span>
                <ul>
                  <li>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17.011"
                      height="17.011"
                      viewBox="0 0 17.011 17.011"
                    >
                      <path
                        id="Icon_material-check-box"
                        data-name="Icon material-check-box"
                        d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                        transform="translate(-4.5 -4.5)"
                        fill="#fff"
                      />
                    </svg>
                    {plan.isRenewal ? (
                      <>
                        {" "}
                        Renewal for{" "}
                        {plan.isKennelLicense
                          ? "kennel license"
                          : plan.isParkLicense
                          ? "Park License"
                          : plan.isDogLicense
                          ? "Dog License"
                          : ""}{" "}
                      </>
                    ) : (
                      <>
                        {plan.isKennelLicense
                          ? "kennel license"
                          : plan.isParkLicense
                          ? "Park License"
                          : plan.isDogLicense
                          ? "Dog License"
                          : ""}
                      </>
                    )}
                  </li>
                </ul>
                <div style={{color: '#d7d7d7', fontSize: '14px', textWrap: 'wrap'}}>{plan.planDescription}</div>
                {JSONParser(plan.categoryDetails, []).map((i) => (
                  <ul>
                    <li>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17.011"
                        height="17.011"
                        viewBox="0 0 17.011 17.011"
                      >
                        <path
                          id="Icon_material-check-box"
                          data-name="Icon material-check-box"
                          d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                          transform="translate(-4.5 -4.5)"
                          fill="#fff"
                        />
                      </svg>
                      {i.categoryName}
                    </li>
                  </ul>
                ))}

                <div className="btn-section">
                  <Button
                    // disabled={DogId == ""}
                    color="danger"
                    data-licenseplanid={plan.licensePlanId}
                    onClick={planSelectFun}
                  >
                    Choose Plan
                  </Button>
                </div>
                {/* {token ? (
                <Link
                  to={{
                    pathname:
                      `/user/chooseplan/` + `${plan.licensePlanId}/${DogId}`,
                  }}
                >
                  <div className="btn-section">
                    <Button
                      disabled={DogId == ""}
                      color="danger"
                      data-licensePlanId={plan.licensePlanId}
                      onClick={alertSignIn}
                    >
                      Choose Plan
                    </Button>
                  </div>
                </Link>
              ) : (
                <div className="btn-section">
                  <Button
                    disabled={DogId == ""}
                    color="danger"
                    data-licensePlanId={plan.licensePlanId}
                    onClick={alertSignIn}
                  >
                    Choose Plan
                  </Button>
                </div>
              )} */}
              </div>
            </Col>
          ) : (
            <div style={{ textAlign: "center" }}>
              <center style={{ marginLeft: "450px" }}>
                {" "}
                No plan is Active
              </center>
            </div>
          )
        )}
      </div>
    </div>
    /* </Row> */
  );
};
